import React from 'react';
import './CircularProgress.css';

function CircularProgress({
  percentage,
  size = 160,
  strokeWidth = 12,
  label,
  subtitle,
  color = '#00d4aa'
}) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="circular-progress" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="progress-ring">
        {/* Background circle */}
        <circle
          className="progress-ring-bg"
          stroke="#e5e5e7"
          strokeWidth={strokeWidth}
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        {/* Progress circle */}
        <circle
          className="progress-ring-circle"
          stroke={color}
          strokeWidth={strokeWidth}
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
          style={{
            strokeDasharray: `${circumference} ${circumference}`,
            strokeDashoffset: offset,
          }}
        />
      </svg>
      <div className="progress-content">
        <div className="progress-value">{percentage}%</div>
        {label && <div className="progress-label">{label}</div>}
        {subtitle && <div className="progress-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
}

export default CircularProgress;
